export const SCA_EVENTS = {
  AUTHENTICATION_METHOD_SELECTED:
    'Embedded Flow - Chosen authentication option',
  AUTHENTICATION_METHODS_PAGE_ERROR:
    'Embedded Flow - "Additional authentication" page error',
  AUTHENTICATION_PAGE_DISPLAYED:
    'Embedded Flow - Display "Additional authentication" page',
  DECOUPLED_VERIFICATION_PAGE_DISPLAYED:
    'Embedded Flow - Display "Confirm in the banking app" page',
  DECOUPLED_VERIFICATION_PAGE_ERROR:
    'Embedded Flow - "Confirm in the banking app" page error',
  GENERIC_ERROR: 'Embedded Flow - Generic error',
  INCORRECT_DATA: 'Embedded Flow - Incorrect data',
  LOGIN_PAGE_DISPLAYED: 'Embedded Flow - Display "Login" page',
  LOGIN_PAGE_ERROR: 'Embedded Flow - "Login" page error',
  PASSWORD_SHOWN: 'Embedded Flow - Password checked by the shopper',
  PUSHED_CODE: 'Embedded Flow - Pushed code',
  PUSHED_DATA: 'Embedded Flow - Pushed payer data',
  REDIRECT_LOADER: 'Embedded Flow - Waiting for redirect after verification',
  REDIRECT_LOADER_ERROR:
    'Embedded Flow - Waiting for redirect after verification - polling error',
  SUBMIT_AUTHENTICATION_METHOD:
    'Embedded Flow - Continue on the SCA method selection view clicked',
  VERIFICATION_PAGE_DISPLAYED:
    'Embedded Flow - Display "Verification code" page',
  VERIFICATION_PAGE_ERROR: 'Embedded Flow - "Verification code" page error',
  PHOTO_OTP_DISPLAYED: 'PhotoOTP challenge image displayed',
  PHOTO_OTP_FAILED_TO_DISPLAY: 'PhotoOTP challenge image error',
} as const;
